import classnames from 'classnames';
import { HTMLProps, ReactNode } from 'react';
import { t } from '~/components/I18n';
import { levelMetaMap } from '~/components/Level/Level.hooks';
import './Level.scss';

export type LevelProps = Omit<HTMLProps<HTMLSpanElement>, 'color'> & {
  level: number;
  type?: 'short' | 'long';
  hasName?: boolean;
  children?: ReactNode;
  color?: boolean;
};

export const Level = ({
  className,
  level,
  type = 'long',
  hasName,
  color = true,
  children,
}: LevelProps) => {
  const levelMeta = levelMetaMap[level];
  return (
    <span
      className={classnames(
        'level',
        `level-type-${type}`,
        {
          'has-name': hasName,
          'has-color': color,
          [`citizen-level-${level}`]: level,
        },
        className
      )}>
      {children || (
        <>
          <span className="level-level">
            {type === 'short' ? 'Lv ' : `${t('citizen_home_level')} `}
          </span>
          <span className="level-value">{level}</span>{' '}
          <span className="level-name">{levelMeta?.title}</span>
        </>
      )}
    </span>
  );
};
